/** Hóa đơn điện tử (e-invoice) — per-tenant PA Vietnam binding + per-invoice issuance (task #1). */
import { apiClient } from "./client";

export type EInvoiceVatRate = "TAX_EXEMPT" | "NOT_DECLARED" | "ZERO" | "FIVE" | "EIGHT" | "TEN";

export interface EInvoiceBinding {
  provider: string; // PA_VIETNAM
  baseUrl: string | null;
  environment: string; // PRODUCTION | SANDBOX
  serial: string | null;
  sellerTaxCode: string | null;
  defaultVatRate: EInvoiceVatRate;
  autoIssue: boolean; // tự phát hành khi hóa đơn PAID
  enabled: boolean;
  hasCredentials: boolean;
}

export interface EInvoiceBindingUpdate {
  provider: string;
  baseUrl?: string | null;
  environment?: string;
  serial?: string | null;
  sellerTaxCode?: string | null;
  defaultVatRate?: EInvoiceVatRate;
  autoIssue?: boolean;
  enabled?: boolean;
  credentials?: Record<string, string>;
}

/** One invoice's e-invoice issuance state (matches EInvoiceIssuanceService.IssuanceView). */
export interface EInvoiceStatus {
  invoiceId: string;
  provider: string;
  status: string; // NOT_ISSUED | PENDING | ISSUED | FAILED | SKIPPED
  serial: string | null;
  idAttr: string | null;
  lookupCode: string | null;
  sentCqt: boolean | null;
  attempts: number;
  lastError: string | null;
}

const SETTINGS = "/v1/clinic/settings/einvoice";

export const einvoiceApi = {
  getBinding: () => apiClient.get<EInvoiceBinding>(SETTINGS).then((r) => r.data),
  updateBinding: (body: EInvoiceBindingUpdate) =>
    apiClient.put<EInvoiceBinding>(SETTINGS, body).then((r) => r.data),
  status: (invoiceId: string) =>
    apiClient.get<EInvoiceStatus>(`/v1/invoices/${invoiceId}/einvoice`).then((r) => r.data),
  issue: (invoiceId: string) =>
    apiClient.post<EInvoiceStatus>(`/v1/invoices/${invoiceId}/einvoice/issue`).then((r) => r.data),
};

export const einvoiceQueryKeys = {
  binding: () => ["einvoice", "binding"] as const,
  status: (invoiceId: string) => ["einvoice", "status", invoiceId] as const,
};
